import { Button } from "@mui/material"
import { useState } from "react"
import Iconify from "minimals-template/components/Iconify"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { exportShareLinkCommentsWorkbook } from "./share-link-comments.controller"

export function ShareLinkCommentsExportButton({ regimeId, folderId, folderName }) {
    const [downloading, setDownloading] = useState(false)

    return (
        <Button
            size="small"
            data-cy="share-link-comments-export"
            disabled={downloading || !regimeId}
            startIcon={<Iconify icon="mdi:file-excel-outline" />}
            endIcon={getLoadingIcon()}
            onClick={download}
        >
            Export
        </Button>
    )

    async function download() {
        try {
            setDownloading(true)
            const excelBase64 = await exportShareLinkCommentsWorkbook({ regimeId, folderId })
            if (!excelBase64) {
                errorSnackbar("Could not export comments")
                return
            }
            const fileName = createFileName(folderName)
            const anchor = document.createElement("a")
            anchor.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${excelBase64}`
            anchor.download = fileName
            anchor.click()
            successSnackbar(`${fileName} created`)
        } catch {
            errorSnackbar("Could not export comments")
        } finally {
            setDownloading(false)
        }
    }

    function getLoadingIcon() {
        if (!downloading) return null
        return <Iconify icon="ic:round-hourglass-empty" className="iconSpin" />
    }
}

function createFileName(folderName) {
    const value = `${folderName || "share-link"}`
        .split(/[^a-zA-Z0-9-_]+/)
        .join("-")
        .toLowerCase()
    const safeName = value || "share-link"
    return `${safeName}-comments.xlsx`
}
